export const FETCH_USER_PREFERNCE_REQUEST = "FETCH_USER_PREFERNCE_REQUEST";
export const FETCH_USER_PREFERNCE_SUCCESS = "FETCH_USER_PREFERNCE_SUCCESS";
export const FETCH_USER_PREFERNCE_FAILURE = "FETCH_USER_PREFERNCE_FAILURE";

export const UPDATE_USER_PREFERENCE_REQUEST = "UPDATE_USER_PREFERENCE_REQUEST";
export const UPDATE_USER_PREFERENCE_SUCCESS = "UPDATE_USER_PREFERENCE_SUCCESS";
export const UPDATE_USER_PREFERENCE_FAILURE = "UPDATE_USER_PREFERENCE_FAILURE";
